// -----------------------------------------------------------------------------
// <copyright file="warning-with-checkbox.model.ts" company="ecoInsight, Inc.">
// 	Copyright © ecoInsight, Inc. All rights reserved.
// </copyright>
// ------------------------------------------------------------------------------

import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

import { CustomWarningComponent } from './custom-warning/custom-warning.component';
import { WarningWithCheckboxComponent } from './warning-with-checkbox/warning-with-checkbox.component';
import { warningWithCheckboxModel } from './warning-with-checkbox/warning-with-checkbox.model';
import { EDialogService } from '../edialog/edialog.service';

export interface CustomWarningConfig {
  title?: string;
  message: string;
  message2?: string;
  boldMessage2?: string;
  icon?: string;
  btnTxt1?: string;
  btnTxt2?: string;
  btnTxt3?: string;
  showIcon?: boolean;
  showCheckBox?: boolean;
  checkBoxMsg?: string;
  spoWarn?: boolean;
  fgWarn?: boolean;
  spoFieldWarn?: boolean;
  copWarnList?: string[];
  cpoWarnList?: string[];
  spoWarnList?: string[];
  infoMessage?: boolean;
  bomtypeErrList?: string[];
}

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private eDialogService = inject(EDialogService);
  constructor() {}

  warning({
    warningMsg = '',
    title = '',
    icon = 'i-warn-n',
    showCheckBox = true,
    btnText = 'cm.ok',
  }: warningWithCheckboxModel): Observable<{ action: string; payload?: any }> {
    const dialog = this.eDialogService.createDialog({
      id: `WarningWithCheckboxComponent ${icon === 'i-warn-n' ? 'warn' : ''}`,
      component: WarningWithCheckboxComponent,
      title: title,
      input: { warningMsg, icon, showCheckBox, btnText },
      showCloseButton: false,
    });
    return dialog.action.pipe(tap(() => dialog.close()));
  }

  openCustomWarningDialog(config: CustomWarningConfig) {
    const dialog = this.eDialogService.createDialog({
      id: config.infoMessage ? 'infoComponent' : 'CustomWarningComponent',
      component: CustomWarningComponent,
      title: config.title ? config.title : '',
      showCloseButton: false,
      input: {
        message: config.message,
        message2: config.message2,
        boldMessage2: config.boldMessage2,
        icon: config.icon ? config.icon : 'i-alert-n',
        btnTxt1: config.btnTxt1 ? config.btnTxt1 : null,
        btnTxt2: config.btnTxt2 ? config.btnTxt2 : null,
        btnTxt3: config.btnTxt3 ? config.btnTxt3 : null,
        showIcon: true,
        showCheckBox: config.showCheckBox,
        checkBoxMsg: config.checkBoxMsg ? config.checkBoxMsg : '',
        spoWarn: config?.spoWarn || false,
        fgWarn: config?.fgWarn || false,
        spoFieldWarn: config?.spoFieldWarn || false,
        copWarnList: config.copWarnList || [],
        cpoWarnList: config.cpoWarnList || [],
        spoWarnList: config.spoWarnList || [],
        bomtypeErrList: config.bomtypeErrList || [],
        infoMessage: config?.infoMessage || false,
      },
    });
    return dialog.action.pipe(
      finalize(() => {
        dialog.close();
      }),
    );
  }
}
